// ============================================================
// autoupdate.js — recarga sola cuando hay una versión nueva desplegada
//
// El nginx de Coolify sirve index.html sin Cache-Control, así que el
// navegador se queda horas con el index.html viejo (y con él, el bundle
// viejo). Dentro de un iframe (crmadmin → panel de Recepción) ni el F5
// lo arregla. Aquí se comprueba, al arrancar y cada pocos minutos, el
// asset-manifest.json del servidor (pidiéndolo SIN caché): si el main.js
// que está corriendo ya no es el desplegado, se recarga la página.
// Se evita recargar mientras hay un formulario abierto (input con foco).
// ============================================================

const INTERVALO_MS = 5 * 60 * 1000;

function bundleActual() {
  const s = Array.from(document.querySelectorAll('script[src]'))
    .map(el => el.getAttribute('src') || '')
    .find(src => /\/static\/js\/main\.[a-z0-9]+\.js/.test(src));
  return s ? s.replace(/^https?:\/\/[^/]+/, '') : null;
}

async function bundleDesplegado() {
  try {
    const r = await fetch(`/asset-manifest.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const m = await r.json();
    return m?.files?.['main.js'] || null;
  } catch { return null; }
}

function usuarioEscribiendo() {
  const a = document.activeElement;
  return !!a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable);
}

let yaRecargando = false;

async function comprobar() {
  if (yaRecargando) return;
  const actual = bundleActual();
  const nuevo = await bundleDesplegado();
  if (!actual || !nuevo || actual === nuevo) return;
  if (usuarioEscribiendo()) return; // se reintenta en la siguiente vuelta
  yaRecargando = true;
  // Recarga saltándose la caché de index.html
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('_v', String(Date.now()));
    window.location.replace(url.toString());
  } catch { window.location.reload(); }
}

export function iniciarAutoActualizacion() {
  if (typeof window === 'undefined' || !('fetch' in window)) return;
  // Primera comprobación pasados unos segundos (que la app arranque tranquila)
  setTimeout(comprobar, 8000);
  setInterval(comprobar, INTERVALO_MS);
  // Y al volver a la pestaña (es cuando más se nota una versión vieja)
  document.addEventListener('visibilitychange', () => { if (!document.hidden) comprobar(); });
}
